// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"327":"Products","869":"Config"}[chunkId] || chunkId) + "." + {"67":"0dc20bc6","197":"847440e5","327":"eca1f8de","496":"1cc5d767","506":"b9ef3e92","515":"66b17e22","533":"41cb3dea","642":"6a7a5bb0","745":"0930c4c7","869":"1186db04","942":"3cd9423a"}[chunkId] + ".js";
};